import { useTranslation } from 'next-i18next';
import classnames from 'classnames';
import Link from '@/components/Link';
import useWhiteLabelLogos, { useWhiteLabelName } from '@/hooks/useWhiteLabelLogos';

import styles from './logo.module.css';

interface LogoProps {
  className?: string,
  variant?: 'simple' | 'filled',
  type?: 'link' | 'block',
  onClick?: () => void,
}

const LogoImage = ({ variant }: LogoProps) => {
  const { t } = useTranslation();
  const alt = useWhiteLabelName() ?? t('main_company_name');
  const customLogo = useWhiteLabelLogos().logo;

  return (
    <img
      className={styles.image}
      src={customLogo ?? (variant === 'filled' ? '/images/logo-filled.svg' : '/images/logo.svg?v=1')}
      alt={alt}
      width="100px"
      height="27px"
    />
  );
};

const Logo = ({ className, variant = 'simple', type = 'link', onClick }: LogoProps) => {
  const { t } = useTranslation();

  if (type === 'link') return (
    <Link
      href="/"
      className={classnames(styles.link, className)}
      title={t('links.product')}
      onClick={onClick}
    >
      <LogoImage variant={variant} />
    </Link>
  );

  return (
    <span
      className={classnames(styles.link, className)}
      title={t('links.product')}
      onClick={onClick}
    >
      <LogoImage variant={variant} />
    </span>
  );
};

export default Logo;
